import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export class LogoAnimation {
	constructor() {
		this.header = document.querySelector(".header");
		this.headerLogo = document.querySelector(".header__logo");
		this.isReducedMotion = window.matchMedia(
			"(prefers-reduced-motion: reduce)"
		).matches;

		if (!this.header || !this.headerLogo) return;

		this.init();
	}

	init() {
		const headerLogoPartTop = this.headerLogo.querySelector(".logo__part--top");
		const headerLogoPartBottom = this.headerLogo.querySelector(
			".logo__part--bottom"
		);

		if (!headerLogoPartTop || !headerLogoPartBottom) return;

		gsap
			.timeline({
				defaults: {
					ease: "power2.inOut",
					duration: this.isReducedMotion ? 0 : 0.5,
				},
				scrollTrigger: {
					trigger: this.header,
					start: "top top",
					end: "+=50",
					toggleActions: "play none none reverse",
				},
			})
			.to(
				headerLogoPartBottom,
				{
					autoAlpha: 0,
					yPercent: 50,
				},
				0
			)
			.to(
				headerLogoPartTop,
				{
					yPercent: 50,
				},
				0
			);
	}
}
